import { Injectable } from '@angular/core';
import {
  AuthChangedHook,
  ErrorService,
  FavoriteList,
  FavoriteService,
  HookEvent,
  HookHandlerAbstract,
  HookPriority,
  SteelFavoriteItemModel,
  switchTap,
  User,
} from '@lobos/library';
import { iif, Observable, of } from 'rxjs';
import { catchError, first } from 'rxjs/operators';

type type = AuthChangedHook;

/**
 * This hook converts locally saved favorites to a real (user-) favorites,
 * as soon as the user logs in.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthorizedConvertLocalFavoritesHandler extends HookHandlerAbstract<type, Observable<User>> {
  constructor(private errorService: ErrorService, private favoriteService: FavoriteService<FavoriteList, SteelFavoriteItemModel>) {
    super();
  }

  ids(): type[] {
    return [{ type: 'AuthChangedHook' }];
  }

  override priority(): number {
    return HookPriority.HIGH;
  }

  override after(event: HookEvent<type, Observable<User>>, result: Observable<User>): Observable<User> {
    return super.after(event, result).pipe(
      switchTap<User>((user?: User) =>
        iif(
          () => !user,
          of(user),
          this.favoriteService.convertLocalToRemote().pipe(
            catchError((error: Error) =>
              of(
                this.errorService.add({
                  label: 'AuthorizedConvertLocalFavorites.after()',
                  ...error,
                  error,
                }),
              ),
            ),
            first(),
          ),
        ),
      ),
    );
  }
}
